import { envService } from '@/core/services/env'
import { getErrorDetails } from './get-error-details'

export const reportError = async (
  err: unknown,
  controller?: AbortController,
) => {
  const url = envService.get('URL')
  const payload = getErrorDetails(err)
  try {
    await fetch(`${url}/api/telegram-report`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
      signal: controller?.signal,
    })
  } catch {
    return
  }
}
